
import person from "@/apiCallers/promise_handler_db/person";
import predmeti from "@/apiCallers/promise_handler_db/predmeti.js";
import { store } from "@/vuex/store.js"
import auth from "@/services/auth";
import { getTokenRedirect, isLoggedIn } from "@/services/auth/redirectLogin";


var curr_user_permission = []


export default
    {
        getLoggedInUser : async function()
        {
            
            let general_user = await getTokenRedirect();
            store.state.aToken = general_user.accessToken;
        },
        // Check if user has reloaded window 
        // If it is reloaded get self
        // It can be used for every view
        checkUserInfo: async function () {
            if (
                store.state.logged_in_user == undefined ||
                store.state.logged_in_user == null
            ) {
                let accessToken = store.state.aToken 
                await person.getSelf(accessToken).then((resp) => {
                    store.state.logged_in_user = resp.data;
                });
            }
            store.state.curr_user_permission = store.state.logged_in_user.user_role.application_permission.map((p) => p.permission_id)

        },
        // Check if current signed in user is allowed to see view
        check_application_permission: async function (wanted_permission) {
            // console.log(store.state.curr_user_permission)
            return (store.state.curr_user_permission.includes(wanted_permission))
        },
        // Check if current signed in user is allowed to see view
        getUserCasePermissions: async function (case_id) {
            await predmeti.getUserCasePermissions(case_id, store.state.logged_in_user.uid).then((resp) => {
                // console.log(resp.data)
            })
        },

        // check if user can see everything
        // if he's got this permission he can override normal case and project permissions
        can_user_override: async function () {
            return (store.state.curr_user_permission.includes("application.all"))
        },

        // check if user can see everything
        // if he's got this permission he can override normal case and project permissions
        is_user_admin: async function () {
            return (store.state.logged_in_user.user_role.id == 1)
        },
        // Save current opened project state
        save_project_permission: function (proj_id, available_permissions) {
            if (store.state.user_project_permissions != undefined ||
                store.state.user_project_permissions == null) {
                store.state.user_project_permissions = {
                    proj_id,
                    available_permissions
                }
            }
            else if (store.state.user_project_permissions.proj_id != proj_id) {
                store.state.user_project_permissions = {
                    proj_id,
                    available_permissions
                }
            }
        },
        // Save current opened project state
        save_case_permission: function (case_id, available_permissions) {
            if (store.state.mapped_case_permission != undefined ||
                store.state.mapped_case_permission == null) {
                store.state.mapped_case_permission = {
                    case_id,
                    available_permissions
                }
            }
            else if (store.state.mapped_case_permission.case_id != case_id) {
                store.state.mapped_case_permission = {
                    case_id,
                    available_permissions
                }
            }
        },


        // Check saved permissions for project
        // Check if wanted permission for selected is inside array
        check_project_permission: function (wanted_permission) {
            // console.log(store.state.user_project_permissions.available_permissions, wanted_permission)

            if (store.state.user_project_permissions == undefined) {
                return true
            }
            if (store.state.logged_in_user.user_role.id == 1) {
                return true;
            } else
                return (store.state.user_project_permissions.available_permissions.includes(wanted_permission))
        },

        // Check saved permissions for project
        // Check if wanted permission for selected is inside array
        check_case_permsision: function (wanted_permission, check_assitent = true) {
            // console.log("checked assistent privilege", store.state.logged_in_user.user_role.id, check_assitent, (store.state.logged_in_user.user_role.id == 9))
            if (store.state.mapped_case_permission == undefined) {
                // console.log("undefined perms")
                return true
            }
            else if (store.state.logged_in_user.user_role.id == 1) {
                // console.log("im admin")
                return true;
            } else if (check_assitent) {
                // console.log("It's true")
                return ((store.state.logged_in_user.user_role.id == 9) || store.state.mapped_case_permission.available_permissions.includes(wanted_permission))
            }
            else {
                // console.log("Checking mapped case permission", store.state.mapped_case_permission.available_permissions, wanted_permission, store.state.mapped_case_permission.available_permissions.includes(wanted_permission))
                return (store.state.mapped_case_permission.available_permissions.includes(wanted_permission))
            }
        },

        am_i_god: function () {
            return store.state.logged_in_user.user_role.id == 1 || store.state.logged_in_user.user_role.id == 9;

        },
        // Naplata analitika (hourly stats): admins + billing managers.
        // Mirrors backend analitics_folder/hourlyAccess.js HOURLY_STATS_ROLE_IDS; the backend is the real gate.
        can_see_hourly_stats: function () {
            const user = store.state.logged_in_user;
            return !!user && !!user.user_role && [1, 7, 8, 9].includes(user.user_role.id);
        }
    }